
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import List from '@material-ui/core/List'

import * as constants from '../../../constants'
import Factor from './Factor'


class FactorList extends Component {
  determineFactorState(factor, index) {
    const {checkedItems, isCounselingSessionDisabled, maxSelectedFactors, topThreeFactors} = this.props
    const isChecked = checkedItems.includes(index)
    const isDisabled =
      isCounselingSessionDisabled || (!isChecked && topThreeFactors.length === maxSelectedFactors)
    return {isChecked, isDisabled}
  }

  // We want to be able to click "disabled" factors to present a warning.
  // Since clicking disabled buttons does nothing, we wrap another
  // click handler around the Factor. To prevent the handler from being
  // called twice we bind to the capture phase on the wrapper element and
  // prevent default if the factor is disabled.
  // ** Not sure why, but stopPropagation from the Factor didn't prevent
  // the event from bubbling so listening for capture phase instead. **
  handleClickCapture(event, factorIsDisabled) {
    if(factorIsDisabled) {
      event.preventDefault()
      this.props.onFactorClick({isDisabled: true})
    }
  }

  render() {
    const {factors, onFactorClick} = this.props
    return (
      <List>
        {factors.map((factor, index) => {
          const {isChecked, isDisabled} = this.determineFactorState(factor, index)
          return (
            <div
              key={index + factor}
              onClickCapture={e => this.handleClickCapture(e, isDisabled)}
            >
              <Factor
                checked={isChecked}
                disabled={isDisabled}
                text={factor}
                onFactorClick={() => onFactorClick({isDisabled, factor, index})}
              />
            </div>
          )
        })}
      </List>
    )
  }
}

FactorList.defaultProps = {
  maxSelectedFactors: constants.MAX_SELECTED_FACTORS
}

FactorList.propTypes = {
  checkedItems: PropTypes.arrayOf(PropTypes.number).isRequired,
  factors: PropTypes.arrayOf(PropTypes.string).isRequired,
  isCounselingSessionDisabled: PropTypes.bool.isRequired,
  maxSelectedFactors: PropTypes.number,
  onFactorClick: PropTypes.func.isRequired,
  topThreeFactors: PropTypes.arrayOf(PropTypes.string)
}

export default FactorList


// WEBPACK FOOTER //
// ./src/components/counseling-session/top-three-factors/FactorList.js